const Divcontainer = ({ children }) => {
  return <div className='text-md mb-6'>{children}</div>;
};

export default Divcontainer;
